export default __webpack_public_path__ + "static/media/2451353-ai.350533fd.png";